var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.$t('Settings')}},[_c('form-settings',{key:'settingsform',ref:"settings_form"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }